export default "__VITE_ASSET__C2tfbUA5__"